import { render } from "./EventList.vue?vue&type=template&id=bd0e1e42&scoped=true"
import script from "./EventList.vue?vue&type=script&lang=js"
export * from "./EventList.vue?vue&type=script&lang=js"

import "./EventList.vue?vue&type=style&index=0&id=bd0e1e42&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-bd0e1e42"

export default script